import { useCallback } from 'react';
import type { BusinessAccountReferAFriendRefereeErrorScreenDisplayed } from '@kiwicom/event-schemas';

import publish from '../../publish';
import { useBaseReferAFriendContext } from '../../common/useBaseReferAFriendContext';
import type { ProgramVersion } from '../../common/useBaseReferAFriendContext';

export type ErrorReason = BusinessAccountReferAFriendRefereeErrorScreenDisplayed['props']['reason'];

const usePublishRefereeErrorScreenDisplayed = () => {
  const getBaseReferAFriendContext = useBaseReferAFriendContext();

  const publishEvent = useCallback(
    (reason: ErrorReason, program_version: ProgramVersion = 'v1') => {
      const baseReferAFriendContext = getBaseReferAFriendContext(program_version);

      publish({
        module: 'account',
        category: 'refer a friend',
        action: 'referee error screen displayed',
        event_name: 'account: refer a friend: referee error screen displayed',
        props: {
          ...baseReferAFriendContext,
          reason,
        },
      });
    },
    [getBaseReferAFriendContext],
  );

  return publishEvent;
};

export default usePublishRefereeErrorScreenDisplayed;
